<template>
  <div id="app" @contextmenu.prevent>
    <router-view/>
  </div>
</template>

<script>
export default {
  data() {
    return {
    };
  },
  mounted() {
    document.onselectstart = function () { return false; }
  },
  methods: {
    
  }
};
</script>

<style lang="less">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
